module.exports = __webpack_public_path__ + "img/login-background.39da0f25.png";